import { environment } from '@accredible-frontend-v2/envs';
import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'dod-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class DoDHeaderComponent {
  homeUrl = environment.directoryOfDirectoriesUrl;
}
